import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { useCurrentUserStore } from "@/stores/currentUserStore"

interface DashboardGreetingProps {
  message: string
}

export const DashboardGreeting: FC<DashboardGreetingProps> = ({ message }) => {
  const currentUser = useCurrentUserStore((state) => state.currentUser)

  return (
    <Box className='flex flex-col gap-y-1'>
      <Typography variant='h6' className='font-bold text-primary' data-testid='dashboard.greeting.welcome'>
        Welcome, {currentUser?.firstName || currentUser?.name}
      </Typography>
      <Typography variant='h5' className='text-primary' data-testid='dashboard.greeting.message'>
        {message}
      </Typography>
    </Box>
  )
}
